<template>
  <div class="vh-100 d-flex flex-column">
    <HeaderComp v-if="$route.path !== '/'" />
    <NavComp v-if="$route.path !== '/'" />
    <router-view />
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp";
import NavComp from "@/components/NavComp.vue";

import utils from "@/libraries/utils/utils.js";

export default {
  name: "AppView",
  components: { HeaderComp, NavComp },
  mounted() {
    const cookies = utils.getCookies();

    if (cookies.backend)
      this.$store.dispatch("login/setSession", cookies.backend);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Product+Sans:100,300,400,500,700,900&display=swap");

* {
  font-family: "Product Sans";
}

:root {
  --futurerent: #0a1734;
  --dark: #0b1734;
}

#app {
  font-family: "Product Sans", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

[layout] {
  width: 80%;
}
</style>
